import loadable from '@loadable/component';
import {ComponentType} from 'react';

export const lazy = (importFunction: () => Promise<{default: ComponentType<any>}>) => loadable(importFunction);
